<template>
    <div class="text-center">
        <VOtpInput
            ref="otpInput"
            separator=""
            :num-inputs="length"
            :is-input-num="true"
            input-type="number"
            :input-classes="'otp-input' + (error ? ' error' : '')"
            class="v-otp-input"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
        ></VOtpInput>
        <b-form-invalid-feedback :state="error ? false : null" class="mt-2s">
            {{ error }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import { OTP_COMPLETED_TIMEOUT } from '@/constants/config';
import VOtpInput from '@bachdgvn/vue-otp-input';

export default {
    name: 'OtpInput',
    components: {
        VOtpInput,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            length: 6,
            error: '',
        };
    },
    computed: {
        otpCode: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        handleOnChange(value) {
            this.clearError();
            setTimeout(() => {
                this.otpCode = value;
                this.$emit('onChange', this.otpCode);
            });
        },
        handleOnComplete(value) {
            setTimeout(() => {
                this.otpCode = value;
                this.$emit('onComplete', this.otpCode);
            }, OTP_COMPLETED_TIMEOUT);
        },
        clearInput() {
            this.$refs.otpInput?.clearInput();
        },
        clearError() {
            this.error = '';
        },
        setError(value) {
            this.error = value;
        },
        validate() {
            this.clearError();
            const form = {
                otpCode: this.otpCode,
            };
            const rules = {
                otpCode: [
                    'required',
                    'min:' + this.length,
                    'max:' + this.length,
                ],
            };
            const messages = {
                'otpCode.required': this.$t(
                    'message.authentication_code_required'
                ),
                'otpCode.min': this.$t('message.min_authentication_code', {
                    min: this.length,
                }),
                'otpCode.max': this.$t('message.max_authentication_code', {
                    max: this.length,
                }),
            };
            const validateErrors = this.$helpers.validateForm(
                form,
                rules,
                messages
            );
            if (
                this.$helpers.isObject(validateErrors) &&
                !this.$helpers.isEmptyObj(validateErrors)
            ) {
                if (validateErrors) {
                    this.error = validateErrors.otpCode;
                }
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'OtpInput';
</style>
